import * as React from "react"
import { Text, Avatar } from "gatsby-interface"
import { GatsbyImage } from "gatsby-plugin-image"
import { MdStar } from "react-icons/md"
import { Link } from "gatsby"

const JavaScriptIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    title="JavaScript logo"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M14 0H2C0.895431 0 0 0.895431 0 2V14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0ZM4.20708 13.3707C4.56151 14.1225 5.25969 14.7454 6.46246 14.7454C7.7943 14.7454 8.70716 14.0365 8.70716 12.4792V7.34553H7.20357V12.4579C7.20357 13.2097 6.89208 13.4029 6.39802 13.4029C5.88259 13.4029 5.6677 13.0486 5.43148 12.6297L4.20708 13.3707ZM10.7481 12.5008L9.5238 13.2097C9.96409 14.0797 10.8663 14.7455 12.2625 14.7455C13.6909 14.7455 14.7542 14.0045 14.7542 12.6511C14.7542 11.3946 14.0346 10.8362 12.7565 10.2884L12.3806 10.1273C11.7362 9.84803 11.457 9.66543 11.457 9.21432C11.457 8.84921 11.7362 8.56997 12.1766 8.56997C12.6062 8.56997 12.8854 8.75254 13.1431 9.21432L14.3138 8.46254C13.8198 7.59257 13.1325 7.25959 12.1766 7.25959C10.834 7.25959 9.97482 8.11886 9.97482 9.24657C9.97482 10.471 10.6944 11.0509 11.7793 11.5127L12.1551 11.6739C12.8425 11.9745 13.2506 12.1571 13.2506 12.6726C13.2506 13.1023 12.8533 13.4137 12.2303 13.4137C11.4892 13.4137 11.0704 13.0271 10.7481 12.5008Z"
    />
  </svg>
)

const TypeScriptIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    title="TypeScript logo"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 14C0 15.1046 0.895431 16 2 16H14C15.1046 16 16 15.1046 16 14V2C16 0.895431 15.1046 0 14 0L2 0C0.895431 0 0 0.895431 0 2V14ZM12.894 7.36254C13.3003 7.46413 13.6102 7.64444 13.8946 7.93905C14.0419 8.09651 14.2603 8.38349 14.2781 8.45206C14.2832 8.47238 13.5873 8.93968 13.1657 9.20127C13.1505 9.21143 13.0895 9.1454 13.021 9.04381C12.8152 8.74413 12.5994 8.6146 12.2692 8.59175C11.7841 8.55873 11.4717 8.8127 11.4743 9.23682C11.4743 9.36127 11.4921 9.43492 11.5429 9.53651C11.6495 9.75746 11.8476 9.88952 12.4698 10.1587C13.6152 10.6514 14.1054 10.9765 14.4102 11.4387C14.7505 11.9543 14.8267 12.7771 14.5956 13.3892C14.3416 14.0546 13.7117 14.5067 12.8254 14.6565C12.5511 14.7048 11.901 14.6971 11.6063 14.6438C10.9638 14.5295 10.3543 14.2121 9.97841 13.7956C9.83111 13.633 9.54413 13.2089 9.5619 13.1784C9.56952 13.1683 9.63556 13.1276 9.70921 13.0844C9.78032 13.0438 10.0495 12.8889 10.3035 12.7416L10.7632 12.4749L10.8597 12.6171C10.9943 12.8229 11.2889 13.1048 11.4667 13.1987C11.9771 13.4679 12.6781 13.4298 13.0235 13.12C13.1708 12.9854 13.2317 12.8457 13.2317 12.64C13.2317 12.4546 13.2089 12.3733 13.1124 12.2337C12.9879 12.0559 12.734 11.906 12.0127 11.5937C11.1873 11.2381 10.8317 11.0171 10.5067 10.6667C10.3187 10.4635 10.141 10.1384 10.0673 9.86667C10.0063 9.64064 9.99111 9.07429 10.0394 8.84571C10.2095 8.04825 10.8114 7.49206 11.68 7.32698C11.9619 7.27365 12.6171 7.29397 12.894 7.36254ZM9.14286 8.68571L9.13778 8.03048L9.13016 7.37778L6.33397 7.37016C4.79746 7.36762 3.53016 7.3727 3.52254 7.38286C3.51238 7.39048 3.50476 7.68762 3.50476 8.04317V8.68571H5.5873V14.6032H7.06032V8.68571H9.14286Z"
    />
  </svg>
)

const StarterImage = ({ starter }) => {
  const screenshot = starter.starterFields?.screenshot?.gatsbyImage

  return (
    <GatsbyImage
      image={screenshot}
      alt={`Screenshot of ${starter.title}`}
      css={imageCss}
    />
  )
}

const GithubStars = ({ starter }) => {
  const { stars } = starter.githubMetaFields
  return stars ? (
    <div css={starsCss}>
      <MdStar /> {stars}
    </div>
  ) : null
}

const isGatsbyStarter = owner =>
  ["gatsby-inc", "gatsbyjs"].includes(owner.toLowerCase())

// fragility is my middle name
export const isHomepageStarter = (name, owner) =>
  name.includes("homepage") && isGatsbyStarter(owner)

const formatName = ({ name, owner }) =>
  isGatsbyStarter(owner)
    ? name.replace(`gatsby-`, ``).replace(`starter-`, ``)
    : `${name}` // shorten name for display

const createOwnerInfo = starter => {
  let name
  let owner

  if (starter.githubMetaFields?.name !== undefined) {
    name = formatName(starter.githubMetaFields)
    owner = starter.githubMetaFields.owner
  } else {
    /* the title is in format repo/starter-name, so we split out the starter-name */
    const [starterOwner, starterName] = starter.title.split("/")
    owner = starterOwner
    name = formatName({ owner: starterOwner, name: starterName })
  }

  if (name.length < 4) name = starter.title

  return { name, owner }
}

const StarterInfo = ({ starter }) => {
  const { name, owner } = createOwnerInfo(starter)
  const hasAvatar = Boolean(starter.githubMetaFields?.avatar)

  return (
    <div css={infoCss}>
      <div css={infoRowCss}>
        <Text as="div" size="S" css={nameCss}>
          {name}
        </Text>
        <GithubStars starter={starter} />
      </div>
      <div css={infoRowCss}>
        <div css={ownerCss}>
          {hasAvatar ? (
            <Avatar
              src={starter.githubMetaFields.avatar}
              label={`This is an avatar of ${owner}`}
              size={"XS"}
              css={ownerAvatarCss}
            />
          ) : null}
          <Text as="div" size="S" css={{ fontWeight: 500 }}>
            {owner}
          </Text>
        </div>
        {isHomepageStarter(name, owner) && (
          <span css={variantIconsCss}>
            <JavaScriptIcon />
            <TypeScriptIcon />
          </span>
        )}
      </div>
    </div>
  )
}

const linkCss = {
  textDecoration: `none`,
  "&:hover": {
    textDecoration: `none`,
  },
}

const infoRowCss = theme => ({
  display: `flex`,
  flexDirection: `row`,
  justifyContent: `space-between`,
  gap: theme.space[1],
})

const variantIconsCss = theme => ({
  display: "flex",
  gap: theme.space[2],
  color: theme.colors.grey[40],
})

const ownerCss = theme => ({
  display: "flex",
  gap: theme.space[2],
  alignItems: "center",
})

const nameCss = theme => ({
  color: theme.colors.grey[90],
  fontWeight: theme.fontWeights.semiBold,
})

const ownerAvatarCss = theme => ({
  width: theme.space[5],
  height: theme.space[5],
})

const cardCss = theme => ({
  borderRadius: theme.radii[3],
  boxShadow: theme.shadows.raised,
  display: `grid`,
  transition: theme.transitions.default,

  "&:hover": {
    transform: `translateY(-${theme.space[1]})`,
    boxShadow: theme.shadows.overlay,
  },
})

const infoCss = theme => ({
  display: `flex`,
  paddingLeft: theme.space[5],
  paddingRight: theme.space[5],
  paddingTop: theme.space[4],
  paddingBottom: theme.space[4],
  position: "relative",
  flexDirection: "column",
  gap: theme.space[2],

  "&:after": {
    display: "block",
    position: "absolute",
    content: `" "`,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: `1px solid ${theme.colors.blackFade[5]}`,
    borderTop: 0,
    borderRadius: `0 0 ${theme.radii[3]} ${theme.radii[3]}`,
  },
})

const imageCss = theme => ({
  borderRadius: `${theme.radii[3]} ${theme.radii[3]} 0 0`,
  position: "relative",

  "&:after": {
    display: "block",
    position: "absolute",
    content: `" "`,
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    border: `1px solid ${theme.colors.blackFade[5]}`,
    borderRadius: `${theme.radii[3]} ${theme.radii[3]} 0 0`,
  },
})

const starsCss = theme => ({
  display: `flex`,
  alignItems: `center`,
  gap: theme.space[2],
  color: theme.colors.grey[50],
  fontSize: theme.fontSizes[1],
})

export function StarterCard({ starter }) {
  return (
    <Link css={linkCss} to={`/starters${starter.githubMetaFields.slug}`}>
      <div css={cardCss}>
        <StarterImage starter={starter} />
        <StarterInfo starter={starter} />
      </div>
    </Link>
  )
}
